const LimitReachedModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-panelBg rounded-2xl p-8 max-w-md w-full border border-boardBorder shadow-2xl">
        {/* Icon & Title */}
        <div className="text-center mb-6">
          <div className="text-6xl mb-4">⏳</div>
          <h2 className="text-3xl font-bold mb-2 text-accentOrange">
            Daily Limit Reached
          </h2>
          <p className="text-textSecondary">
            You've used your free match for today. Come back tomorrow for more!
          </p>
        </div>

        {/* Info */}
        <div className="bg-buttonHover rounded-lg p-4 mb-6">
          <h3 className="text-white font-bold mb-2">Free Plan</h3>
          <ul className="text-textSecondary text-sm space-y-2">
            <li>✓ 1 match per day</li>
            <li>✓ Full AI commentary</li>
            <li>✓ Match history tracking</li>
          </ul>
        </div>

        {/* Actions */}
        <button 
          onClick={onClose}
          className="w-full py-3 bg-accentGreen hover:bg-[#729E43] text-white rounded-lg transition font-medium"
        >
          Got It
        </button>
      </div>
    </div>
  );
};

export default LimitReachedModal;
